export class ExamSummary {
    passed: boolean;
    percentOfCompletion: number;
}
